export default "__VITE_ASSET__BdtAvC72__"